export default __webpack_public_path__ + "static/media/ic_info_light.7a8114c4.svg";